export default "__VITE_ASSET__CPUySFq0__"